import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => ({
    currentpage: getCurrentPage(state),
    isAuthenticated: state.context.session.isAuthenticated,
    location: getLocation(state),
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const ADIAuthenticatedView: React.FC<Props> = ({ id, currentpage, isAuthenticated, location }) => {
    React.useEffect(() => {
        let getOrderUrl = location.pathname.toLocaleLowerCase();
        if (!isAuthenticated && (location.pathname.includes("MyAccount") || getOrderUrl.includes("quickorder"))) {
            const returnUrl = location.pathname;
            window.location.href = `/MyAccount/SignIn?returnUrl=${encodeURIComponent(returnUrl)}`;
        }
    }, []);
    if (!isAuthenticated) {
        return null;
    }
    return <Zone contentId={id} zoneName="Content1" />;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, null)(ADIAuthenticatedView),
    definition: {
        displayName: "ADI Authenticated View",
        group: "Common",
    },
};

export default widgetModule;
